export enum SurveySubmitStatus {
    Accepted,
    Pending,
    Public
}